export const TEXT = 'text';
export const FILE_ID = 'fileId';